import styled from 'styled-components';

export const HolidayCalenderWrapper = styled.div(
  props => `
  border-left: .2rem solid ${props.theme.colors.ash.medium};
  width:28rem;
  `,
);

export const HolidayCalenderHeader = styled.div(
  props => `
  font-size:${props.theme.font.base};
  color:${props.theme.colors.downriver.medium};
  text-transform:uppercase;
  padding:${props.theme.spacing.xxlarge} 0 ${props.theme.spacing.xlarge} ${props.theme.spacing.large};
  `,
);

export const HolidayCalenderListWrap = styled.ul(
  props => `
  height:28rem;
  overflow-y:scroll;
  padding: ${props.theme.spacing.small} ${props.theme.spacing.large};
  `,
);

export const HolidayListItem = styled.li(
  props => `
  display:flex;
  align-items:center;
  width:100%;
  box-shadow: 0 .1rem .4rem 0  ${props.theme.colors.shadow.light};
  border-radius: ${props.theme.misc.borderRadius.base};
  padding:${props.theme.spacing.custom(7)} ${props.theme.spacing.large};
  margin-bottom:${props.theme.spacing.large};
  `,
);

export const CircularShape = styled.span(
  props => `
  display: list-item;
  list-style-type: disc;
  list-style-position: inside;
  color:${props.theme.colors.goGreen.base};
  font-size:${props.theme.font.custom(20)};
  width:7%
  `,
);

export const HolidayListDate = styled.span(
  props => `
  font-size:${props.theme.font.custom(14)};
  font-weight:bold;
  color:${props.theme.colors.downriver.base};
  width:25%;
  `,
);

export const HolidayListFestival = styled.span(
  props => `
  font-size:${props.theme.font.custom(14)};
  color:${props.theme.colors.goBrandBlue.base};
  margin-left:${props.theme.spacing.xsmall};
  width:70%;
  `,
);
